import { getProductAliasFromType } from '../../lib/productHelpers';
import { fingerprint } from '../../lib/fingerprint';

export const TOGGLE_ITEMS_DISCLAIMER_CHECKED = 'TOGGLE_ITEMS_DISCLAIMER_CHECKED';
export const RECEIVE_INITIAL_PAGE_LOAD_PARAMS = 'RECEIVE_INITIAL_PAGE_LOAD_PARAMS';
export const UPDATE_STEP_1_COMPLETE_STATUS = 'UPDATE_STEP_1_COMPLETE_STATUS';
export const UPDATE_STEP_2_COMPLETE_STATUS = 'UPDATE_STEP_2_COMPLETE_STATUS';
export const UPDATE_ALL_STEPS_COMPLETE_STATUS = 'UPDATE_ALL_STEPS_COMPLETE_STATUS';
export const UPDATE_LOCALE = 'UPDATE_LOCALE';
export const UPDATE_EXCHANGES_ENABLED = 'UPDATE_EXCHANGES_ENABLED';
export const UPDATE_GIFT_FLAG = 'UPDATE_GIFT_FLAG';
export const UPDATE_GIFT_EMAIL = 'UPDATE_GIFT_EMAIL';
export const UPDATE_IS_SIMPLE_RETURNS = 'UPDATE_IS_SIMPLE_RETURNS';
export const STORE_OVERRIDE_CODE = 'STORE_OVERRIDE_CODE';
export const STORE_BROWSER_FINGERPRINT = 'STORE_BROWSER_FINGERPRINT';
export const NAVIGATION_TO_LANDING_PAGE = 'NAVIGATION_TO_LANDING_PAGE';
export const NAVIGATION_TO_STEP_1 = 'NAVIGATION_TO_STEP_1';
export const NAVIGATION_TO_STEP_2 = 'NAVIGATION_TO_STEP_2';
export const UPDATE_SECURE_MODE = 'UPDATE_SECURE_MODE';
export const RECEIVE_PENDING_CANCEL_RETURN_ID = 'RECEIVE_PENDING_CANCEL_RETURN_ID';
export const RECEIVE_DISPLAY_HELP_FLAG = 'RECEIVE_DISPLAY_HELP_FLAG';
export const RECEIVE_PICKUPS_MODAL_VERSION = 'RECEIVE_PICKUPS_MODAL_VERSION';
export const RECEIVE_PICKUPS_ENABLE_CTA = 'RECEIVE_PICKUPS_ENABLE_CTA';
export const RECEIVE_ACCESS_TOKEN = 'RECEIVE_ACCESS_TOKEN';
export const RECEIVE_CURRENCY_FORMAT = 'RECEIVE_CURRENCY_FORMAT';
export const SET_LOADING = 'SET_LOADING';
export const SET_DEFER_OVERRIDE = 'SET_DEFER_OVERRIDE';
export const SET_SHOW_ADDRESS_ON_STEP_3 = 'SET_SHOW_ADDRESS_ON_STEP_3';
export const CAPTURE_USER_EMAIL = 'CAPTURE_USER_EMAIL';

export const toggleItemsDisclaimerChecked = () => ({
  type: TOGGLE_ITEMS_DISCLAIMER_CHECKED,
});

export const receiveInitialPageLoadParams = (params) => ({
  type: RECEIVE_INITIAL_PAGE_LOAD_PARAMS,
  data: { params },
});

export const updateStep1Complete = (step1Complete) => ({
  type: UPDATE_STEP_1_COMPLETE_STATUS,
  data: { step1Complete },
});

export const updateStep2Complete = (step2Complete) => ({
  type: UPDATE_STEP_2_COMPLETE_STATUS,
  data: { step2Complete },
});

export const updateAllStepsComplete = (allStepsComplete) => ({
  type: UPDATE_ALL_STEPS_COMPLETE_STATUS,
  data: { allStepsComplete },
});

export const updateLocale = (locale = 'en_US') => {
  const [language, country] = locale.split('_');
  const languageCode = language.toLowerCase();
  const countryCode = country.toUpperCase();
  return {
    type: UPDATE_LOCALE,
    data: {
      locale: `${languageCode}_${countryCode}`,
      languageCode,
      countryCode,
    },
  };
};

export const updateExchangesEnabled = (exchangesEnabled) => ({
  type: UPDATE_EXCHANGES_ENABLED,
  data: { exchangesEnabled },
});

// TODO: This action generates a path for $location.path
//       We need to revisit this action when we start to
//       migrate $location to react router.

export const getRedirectUrlPath = (step) => (_, getState) => {
  const { page: { productType } = {}, retailerSettings: { name: retailerName } = {} } = getState();

  const productAlias = getProductAliasFromType(productType);

  if (!step) return `/${retailerName}/${productAlias}/`;

  return `/${retailerName}/${productAlias}/${step}`;
};

export const updateGiftFlag = (giftOrder) => ({
  type: UPDATE_GIFT_FLAG,
  data: { giftOrder },
});

export const updateGiftEmail = (giftEmail) => ({
  type: UPDATE_GIFT_EMAIL,
  data: { giftEmail },
});

export const storeOverrideCode = (overrideCode) => ({
  type: STORE_OVERRIDE_CODE,
  data: { overrideCode },
});

export const generateBrowserFingerprint = () => async (dispatch) => {
  const browserFingerprint = await fingerprint();
  return dispatch({
    type: STORE_BROWSER_FINGERPRINT,
    data: {
      browserFingerprint,
    },
  });
};

export const broadcastNavigationToLandingPage = () => ({
  type: NAVIGATION_TO_LANDING_PAGE,
});

export const broadcastNavigationToStep1 = () => ({
  type: NAVIGATION_TO_STEP_1,
});

export const broadcastNavigationToStep2 = () => ({
  type: NAVIGATION_TO_STEP_2,
});

export const updateIsSimpleReturns = (isSimpleReturns) => ({
  type: UPDATE_IS_SIMPLE_RETURNS,
  data: {
    isSimpleReturns,
  },
});

export const updateSecureMode = (secureMode) => ({
  type: UPDATE_SECURE_MODE,
  data: {
    secureMode,
  },
});

export const receivePendingCancelReturnId = (pendingCancelReturnId) => ({
  type: RECEIVE_PENDING_CANCEL_RETURN_ID,
  data: {
    pendingCancelReturnId,
  },
});

export const receiveDisplayHelpFlag = (displayHelp) => ({
  type: RECEIVE_DISPLAY_HELP_FLAG,
  data: {
    displayHelp,
  },
});

export const receivePickupsModalVersion = (pickupsModalVersion) => ({
  type: RECEIVE_PICKUPS_MODAL_VERSION,
  data: {
    pickupsModalVersion,
  },
});

export const receivePickupsEnableCTA = (pickupsEnableCTA) => ({
  type: RECEIVE_PICKUPS_ENABLE_CTA,
  data: {
    pickupsEnableCTA,
  },
});

export const receiveAccessToken = (accessToken) => ({
  type: RECEIVE_ACCESS_TOKEN,
  data: {
    accessToken,
  },
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  data: {
    loading,
  },
});

export const setDeferOverride = (deferOverride) => ({
  type: SET_DEFER_OVERRIDE,
  data: { deferOverride },
});

export const setShowAddressOnStep3 = (showAddressOnStep3) => ({
  type: SET_SHOW_ADDRESS_ON_STEP_3,
  data: {
    showAddressOnStep3,
  },
});

export const shouldCaptureUserEmail = (captureUserEmail) => ({
  type: CAPTURE_USER_EMAIL,
  data: {
    captureUserEmail,
  },
});
